module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAIVJREFUOBFjYBgFpIZAbW2tLggTq4+FWIV///4Nhqq9TIweJmIUkaOGZgYzE+Oaqqqqhn///tX////fwc7OjvHw4cMHiNFHlBqQ4SBMlGKgIkaYwoqKiltAtiqMTyZ9u6OjQ41MvQOsbeCDgtTIG3rJjWY5j2YGE126MTMzrx3gFDxUrQcAiQI2mLDkBN4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_HeightMin_disabled.png
// module id = 315
// module chunks = 0